import { render, staticRenderFns } from "./RegistPopup.vue?vue&type=template&id=547a0409&scoped=true&"
import script from "./RegistPopup.vue?vue&type=script&lang=js&"
export * from "./RegistPopup.vue?vue&type=script&lang=js&"
import style0 from "./RegistPopup.vue?vue&type=style&index=0&id=547a0409&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a0409",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
